import { DeviceStateFlag } from '@racemap/utilities/consts/events';
import {
  formatDateAndTime,
  formatOffsetInMeterBasedOnUnitType,
  formatTimeDuration,
} from '@racemap/utilities/formatting';
import {
  type Geofence,
  type PreparedStarterInfo,
  sortTimes,
  testEventHasVirtDuration,
} from '@racemap/utilities/functions/timing';
import type { RacemapEvent } from '@racemap/utilities/types/events';
import type { Splits } from '@racemap/utilities/types/types';
import type { Immutable } from 'immer';
import { ICON_CDN_PATH } from '../../../BasicComponents/IconChooser/IconChooser';
import type { Column } from '../TableBody';
import { Cell } from './BasicCell';
import { LARGE_TIME_COL_WIDTH, TimesColumHeaderTitle } from './TimesCol';

function StartTimesColComponent({ starterInfo }: { starterInfo: Immutable<PreparedStarterInfo> }) {
  return (
    <Cell
      style={{
        opacity: starterInfo.state === DeviceStateFlag.DISQUALIFIED ? 0.7 : 1,
        fontStyle: starterInfo.state === DeviceStateFlag.DISQUALIFIED ? 'italic' : 'normal',
      }}
    >
      {starterInfo.results[0]?.time != null ? formatDateAndTime(starterInfo.results[0]?.time) : '-'}
    </Cell>
  );
}

export function getStartTimesCol(
  event: Immutable<RacemapEvent>,
  splits: Immutable<Splits>,
  timekeepings: Immutable<Array<Geofence>>,
): Column {
  const eventHasVirtDuration = testEventHasVirtDuration(event);
  const unit = event.playerOptions.unitType;
  const visibleElements = event.modules.timing.visibleElements;
  const startGeofence = timekeepings[0];
  const splitIconName = splits?.find((split) => split.id === startGeofence.id)?.icon;
  const name = splits == null ? 'Start' : startGeofence.name;
  const icon = splitIconName;
  const distance = eventHasVirtDuration
    ? formatTimeDuration(startGeofence.timeOffset)
    : formatOffsetInMeterBasedOnUnitType(startGeofence.offset, unit);
  return {
    key: 'times_start',
    title: (
      <TimesColumHeaderTitle
        headerContent={visibleElements.headerContent}
        name={name}
        icon={icon != null ? icon : `${ICON_CDN_PATH}/start-02_tickless.svg`}
        distance={distance}
      />
    ),
    width: LARGE_TIME_COL_WIDTH,
    render: function renderer(row: Immutable<PreparedStarterInfo>) {
      return <StartTimesColComponent starterInfo={row} />;
    },
    sorter: (a: Immutable<PreparedStarterInfo>, b: Immutable<PreparedStarterInfo>) =>
      sortTimes(a?.results[0]?.time, b?.results[0]?.time),
  };
}
